module.exports = __webpack_public_path__ + "Micheal WONG-7b5846df.png";